import { useEffect, useRef, useState } from 'react'
import { ENABLE_INLINE_EDIT } from '@/lib/flags'
import { getText, setText } from '@/lib/content'

interface EditableProps {
  tkey: string;
  children?: React.ReactNode;
  as?: keyof JSX.IntrinsicElements;
  className?: string;
}

export default function Editable({ tkey, children, as: Tag = 'span', className }: EditableProps) {
  const ref = useRef<HTMLElement>(null)
  const fallback = typeof children === 'string' ? children : ''
  const [value, setValue] = useState(getText(tkey, fallback))

  useEffect(() => {
    setValue(getText(tkey, fallback))
  }, [tkey, fallback])

  const onInput = (e: React.FormEvent<HTMLElement>) => {
    const v = e.currentTarget.textContent || ''
    setValue(v)
    setText(tkey, v)
  }

  const TagComponent = Tag as React.ElementType;

  return (
    <TagComponent
      ref={ref}
      className={className}
      contentEditable={ENABLE_INLINE_EDIT}
      suppressContentEditableWarning
      onInput={ENABLE_INLINE_EDIT ? onInput : undefined}
      data-edit-key={tkey}
    >
      {value}
    </TagComponent>
  )
}
